import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import Log, {Errors} from "@khan/logging";
import {mediaQueries} from "@khan/shared-styles";
import {cssUrl, staticUrl} from "@khan/urls";

import {requireYouTubeAPI} from "#video-package/util.ts";

const YOUTUBE_PLAYER_ID = "khanKidsPlayer";

type Props = Record<any, any>;
type State = {
    showCustomThumbnail: boolean;
};

export default class KhanKidsLandingPage extends React.Component<Props, State> {
    player: any;

    state: State = {
        showCustomThumbnail: true,
    };

    componentDidMount() {
        requireYouTubeAPI(
            () => {
                // @ts-expect-error - TS2339 - Property 'YT' does not exist on type 'Window & typeof globalThis'.
                this.player = new window.YT.Player(YOUTUBE_PLAYER_ID, {
                    videoId: "yqZfM2W6tSQ",
                    // For some reason when set to 100% the video iframe
                    // actually expands beyond the parent size.
                    height: "96%",
                    width: "97%",
                    rel: 0,
                    showinfo: 0,
                });
            },
            () => {
                Log.error("failed to load YouTube API", Errors.Internal);
            },
        );
    }

    handleVideoCtaClick: () => void = () => {
        this.setState({showCustomThumbnail: false});
        this.player && this.player.playVideo();
    };

    render(): React.ReactNode {
        const {showCustomThumbnail} = this.state;
        return (
            <div className={css(styles.videoContainer)}>
                {showCustomThumbnail && (
                    <button
                        className={css(styles.fauxVideoBackground)}
                        onClick={this.handleVideoCtaClick}
                        aria-controls={YOUTUBE_PLAYER_ID}
                        aria-label={t`Plays a YouTube video about Khan Academy Kids`}
                    >
                        <img
                            alt=""
                            aria-hidden={true}
                            className={css(styles.fauxVideoPlayButton)}
                            src={staticUrl("/images/kids/play-button.svg")}
                        />
                    </button>
                )}
                {/* eslint-disable-next-line jsx-a11y/media-has-caption -- TODO: Address a11y error */}
                <video
                    id={YOUTUBE_PLAYER_ID}
                    className={css(styles.youtubeVideo)}
                />
            </div>
        );
    }
}

const styles = StyleSheet.create({
    videoContainer: {
        position: "relative",
        width: 482,
        height: 270,

        [mediaQueries.xsOrSmaller]: {
            width: 294,
            height: 165,
        },
    },

    youtubeVideo: {
        position: "absolute",
        // Hacks to accomodate the fact that iframe seems to be bigger
        // the fake thumbnail when both are 100% of the same parent...
        left: 5,
        top: 3,
        zIndex: 1,
        boxShadow: "0 8px 8px 0 rgba(0, 0, 0, 0.5)",
    },

    fauxVideoBackground: {
        position: "absolute",
        left: 0,
        top: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2,
        height: "100%",
        width: "100%",
        border: "none",
        backgroundColor: "transparent",
        backgroundImage: cssUrl("/images/kids/video-thumbnail.svg"),
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        cursor: "pointer",
    },

    fauxVideoPlayButton: {
        height: 104,
        margin: "auto",

        [mediaQueries.xsOrSmaller]: {
            height: 67,
        },
    },
});
